/* @flow */
import * as React from 'react';
import { ElectroTooltip } from 'components/ExtendedUiElements/customized';

export type OptionalTooltipProps = {
  content?: string,
};

export default class OptionalTooltip extends React.PureComponent<OptionalTooltipProps> {
  render() {
    const { children, content } = this.props;

    if (content) {
      return (
        <ElectroTooltip title={content} arrow>
          {children}
        </ElectroTooltip>
      );
    }

    return children;
  }
}
